import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        const { blockType, blockId } = this.props;
        if (blockType || blockId) {
            console.error(
                `[LandingMaker] Section ${blockType || 'unknown'} (${blockId || '?'}) failed:`,
                error,
                info
            );
        } else {
            console.error('[LandingMaker] ErrorBoundary caught:', error, info);
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (
                <div className="py-8 text-center">
                    <p className="text-gray-400 text-sm">
                        Esta seccion no pudo cargarse
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}
